import { defineComponent, h } from 'vue';
import utils from '../../../Shared/utils.jsx';
import BaseComponent from './BaseComponentMixin.jsx';

export default defineComponent({
    name: 'document-bootstrap-dsgn',
    mixins: [BaseComponent],
    data: function () {
        return {
        }
    },
    render(h) {
        let name;
        if (!this.Name)
            name = this.type;
        else
            name = this.Name + ': ' + this.type || 'Unnamed';

        return (
            <div
                class={{ 'designer-container': true, selected: this.selected$ }}
                style={{ backgroundColor: "lightyellow", border: "solid 1px silver", borderRadius: "8px", margin: "2px", padding: "2px", xx: "#a0ffa0" }}
                onClick={(e) => this.handleClick(e)}>
                <div class={{ "designer-container-hovering": true, 'designer-container-selected': this.selected$ }}></div>
                <i class="mdi mdi-bootstrap" /> {name}<br />
            </div>
        );
    }
});